import type { CrossJoinTargetProduct } from '../../common/types';
import type { NonContextualNote, NonContextualNoteParams } from '../types';

import { nonContextualNoteMessages } from './messages';

export const buildNonContextualNote = ({
	displayName,
	userEmail,
	fullName,
	targetProduct,
	formatMessage,
}: NonContextualNoteParams): NonContextualNote | undefined => {
	const requestingUser = displayName || fullName || userEmail;

	const noteMessage = getNote(targetProduct);

	if (!noteMessage || !requestingUser) {
		return undefined;
	}

	const noteText = formatMessage(noteMessage, {
		requestingUser,
	});
	return noteText;
};

export const getNote = (
	targetProduct: CrossJoinTargetProduct,
):
	| {
			defaultMessage: string;
			description: string;
			id: string;
	  }
	| undefined => {
	switch (targetProduct) {
		case 'jira-product-discovery':
			return nonContextualNoteMessages.jpdValueProp;
		case 'jira-software':
			return nonContextualNoteMessages.jiraValueProp;
		case 'loom':
			return nonContextualNoteMessages.loomValueProp;
		case 'confluence':
			return nonContextualNoteMessages.confluenceValueProp;
		default:
			return undefined;
	}
};

export { nonContextualNoteMessages } from './messages';
